export const FACEBOOK_LOGIN_SERVICE = 'facebook';
export const TOKEN_COOKIE_KEY = '_t';
export const USER_PAYLOAD_COOKIE_KEY = '_u';
